<script lang="ts" setup>
import { computed } from 'vue';
import { useRequestSessionStore } from '@Stores/requestSession.store';
import { WELCOME_CONTENT_BY_REQUEST_TYPE } from '@Constants/welcomeContent.constants';
import { RequestType } from '@Enums/requestType.enum';

const requestSessionStore = useRequestSessionStore();

const welcomeContent = computed(() => {
    const requestType = (requestSessionStore.requestSummary?.requestType ??
        RequestType.Unknown) as RequestType;
    return (
        WELCOME_CONTENT_BY_REQUEST_TYPE[requestType] ??
        WELCOME_CONTENT_BY_REQUEST_TYPE[RequestType.Unknown]
    );
});
</script>

<template>
    <div v-if="welcomeContent" class="showcase-image">
        <img
            class="showcase-image__img"
            :src="welcomeContent.imageSrc"
            alt=""
        />
    </div>
</template>

<style lang="scss" scoped>
@use "certifid-v2-client-hub-styles" as *;

.showcase-image {
    display: flex;
    flex: 1 1 auto;
    flex-flow: column;
    align-items: center;
    margin-top: 22vh;

    &__img {
        width: 27.875rem;
        height: 23.00256rem;
        margin-bottom: 0.69rem;
    }
}
</style>
